/**
 * @generated SignedSource<<90d19be9017e7bf44f76c4913635bb45>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DeletePostButtonMutation$variables = {
  connections: ReadonlyArray<string>;
  id: string;
};
export type DeletePostButtonMutation$data = {
  readonly deletePost: {
    readonly deletedPostId: string | null;
  };
};
export type DeletePostButtonMutation = {
  response: DeletePostButtonMutation$data;
  variables: DeletePostButtonMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedPostId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "DeletePostButtonMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "DeletePostResponse",
        "kind": "LinkedField",
        "name": "deletePost",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "DeletePostButtonMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "DeletePostResponse",
        "kind": "LinkedField",
        "name": "deletePost",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteEdge",
            "key": "",
            "kind": "ScalarHandle",
            "name": "deletedPostId",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2a71a8e8b749dd9ac9b57221daeadc30",
    "id": null,
    "metadata": {},
    "name": "DeletePostButtonMutation",
    "operationKind": "mutation",
    "text": "mutation DeletePostButtonMutation(\n  $id: ID!\n) {\n  deletePost(id: $id) {\n    deletedPostId\n  }\n}\n"
  }
};
})();

(node as any).hash = "55c5da49d00a46b263cb2a9f33562ec8";

export default node;
